var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightWhiteMedium = function SvgArrowRightWhiteMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.201 1.175 5.018 5.018-5.018 5.018a.688.688 0 1 0 .973.973l5.5-5.5a.688.688 0 0 0 0-.973l-5.5-5.5a.688.688 0 1 0-.973.973Z"
  })));
};
export default SvgArrowRightWhiteMedium;